import type {
  CoreBookingPayment,
  CoreBookingPaymentPayload,
  ParameterID,
} from '@flecto/types'

import { api } from '../../../services/api'
import { getBookingSendEmailAndSmsParams } from '../../../utils/getBookingSendEmailAndSmsParams'

export type UpdateBookingPaymentOptions = {
  send_email?: boolean
  send_sms?: boolean
}

/**
 * Update a booking payment by ID.
 *
 * @endpoint PUT /api/saas/me/bookings/{bookingId}/payments/{paymentId}
 * @scope saas
 * @see https://flecto.dev/api-4724157
 */

export async function updateBookingPayment(
  bookingId: ParameterID,
  paymentId: ParameterID,
  payment: CoreBookingPaymentPayload,
  options?: UpdateBookingPaymentOptions
): Promise<CoreBookingPayment> {
  const body: CoreBookingPaymentPayload = payment

  const response = await api.put(
    `/api/saas/me/bookings/${bookingId}/payments/${paymentId}`,
    body,
    { params: getBookingSendEmailAndSmsParams(options) }
  )

  return response.data.booking_payment
}
